import { Either, left, right } from "fp-ts/lib/Either";
import ServiceEntity from "../../../../domain/entities/ServiceEntity";
import ServiceDto from "../../../dto/ServiceDto";
import RestApi from "../../../settings/RestApi";

const restApi = new RestApi();

export const getServiceByIdApiImpl = async (
    id: string, 
): Promise<Either<string, ServiceEntity>> => {
    try {
        let relativeUrl = `/qrcodes/register-qr-user/${id}`;
        
        const response = await restApi.get(relativeUrl);
        const data = response.vehicle_register;
        const service = ServiceDto.fromJson(data);
        console.log("Service obtained:", service);
        return right(service);
    } catch (error) {
        const errorMessage = error instanceof Error ? error.message : String(error);
        
        if (errorMessage.includes("qr_inactive")) {
            return left("QR inactivo");
        }
        
        return left(errorMessage || 'Error al obtener el servicio del auto');
    }
};

